import { ReactElement, useRef } from 'react';

import { usePlayAreaSetter } from '@pp/core/src/hooks/usePlayAreaSetter';
import { useIsPortrait } from '@pp/core/src/styles/hooks/media';

import { BettingActionGridConnected } from '../../bettingActionGrid/BettingActionGridConnected';
import { MobileCashedAndTotalBets } from '../../tableSheet/mobileCashedAndTotalBets/MobileCashedAndTotalBets';

import styles from './bettingActionCell.module.css';

export const BettingActionCellConnected = (): ReactElement => {
  const isPortrait = useIsPortrait();

  const bettingGridRef = useRef<HTMLDivElement>(null);

  usePlayAreaSetter(bettingGridRef);

  return (
    <>
      <div className={styles.bettingActionCell}>
        {isPortrait && <MobileCashedAndTotalBets />}
        <BettingActionGridConnected />
      </div>
      <div ref={bettingGridRef} className={styles.bettingGridCell_reference} />
    </>
  );
};
